export const signTypes = {
    LOGIN_REQUEST: 'LOGIN loading',
    LOGIN_SUCCESS: 'LOGIN success',
    LOGIN_ERROR: 'LOGIN has error',

    LOGIN_VIEW_CHANGE: 'LOGIN MOde change',
    TABS_CHANGE: 'TABS CHANGE',

    REGISTER_REQUEST: 'REGISTER request',
    REGISTER_SUCCESS: 'REGISTER is finished',
    REGISTER_ERROR: 'REGISTER has error',

    REGISTER_RECOGNIZED_REQUEST: 'Recognising email',
    REGISTER_RECOGNIZED_ERROR: 'Email isnot recognized. continue',
    REGISTER_RECOGNIZED_EMAIL: 'Email is recognized. change to login',

    RESET_PASSWORD_REQUEST: 'reset password init ',
    RESET_PASSWORD_SUCCESS: 'sent link to new password form ',
    RESET_PASSWORD_ERROR: 'not reset password ',

    SET_PASSWORD_LOADING: 'NEW PASSWORD loading',
    SET_PASSWORD_READY: 'NEW PASSWORD ready',
    SET_PASSWORD_NOT_VERIFY: 'NEW PASSWORD token no verify',

    SET_PASSWORD_REQUEST: 'NEW PASSWORD save',
    SET_PASSWORD_SUCCESS: 'NEW PASSWORD set and redirect',
    SET_PASSWORD_ERROR: 'NEW PASSWORD has error',

    LOGOUT: 'Logout',
    LOGOUT_REQUEST: 'Logout request',

    LOGGED_REQUEST: 'Logged status request',
    LOGGED_SUCCESS: 'Logged status finished',
    LOGGED_ERROR: 'Logged status error',
};
